(function attachJudesStartklar(root, factory) {
  const api = factory(root);
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.JudesStartklar = api;
}(typeof globalThis !== 'undefined' ? globalThis : this, function createJudesStartklar(root) {
  'use strict';

  const BASE = 'https://jodesfamily.com';

  // ---------------------------------------------------------------------------
  // Mode 1, legacy shared gift links (?startklar=STARTKLAR2/3/4).
  // Kept exactly as the live theme ships them today (dd33126), so old emails
  // keep their inner-diaper gift until the Flow switch.
  // ---------------------------------------------------------------------------
  const offers = Object.freeze({ full: { code: 'STARTKLAR2', quantity: 2, base: 21 }, comfort: { code: 'STARTKLAR3', quantity: 3, base: 28 }, allin: { code: 'STARTKLAR4', quantity: 4, base: 35 } });
  const innerId = '40460286296253';
  function offerFor(recipe, enabled) { return enabled && recipe.bundleType === 'klassik' && recipe.sizeKey === 's2' ? offers[recipe.routineKey] || null : null; }
  function legacyEntry(url, recipes) {
    const classic = /\/products\/klassik-set\/?$/.test(url.pathname);
    const values = url.searchParams.getAll('startklar');
    const code = values.length === 1 ? values[0] : '';
    const match = Object.entries(offers).find(([, offer]) => offer.code === code);
    const enabled = classic && !!match;
    const selected = enabled ? recipes.find(r => r.bundleType === 'klassik' && r.sizeKey === 's2' && r.routineKey === match[0]) : null;
    return { enabled, recipe: selected || null };
  }
  function legacyApply(result, recipe, catalog, enabled) {
    const offer = offerFor(recipe, enabled); if (!offer) return result;
    const variant = catalog[innerId];
    const line = result.cartPayload.items.find(i => String(i.id) === innerId);
    if (!variant || variant.available === false || !line || line.quantity !== offer.base || result.pricing.mode !== 'standard_discount') throw Error('STARTKLAR selection is unavailable');
    const value = variant.priceMinor * offer.quantity;
    line.quantity += offer.quantity;
    line.properties = { ...line.properties, _judes_bundle_role: 'mixed', _judes_bundle_gift_quantity: String(offer.quantity), _judes_startklar: offer.code };
    result.giftComponents.push({ variantId: innerId, quantity: offer.quantity });
    result.discount.code += ',' + offer.code;
    result.discount.amountMinor += value;
    result.pricing.giftValueMinor += value;
    result.pricing.retailValueMinor += value;
    result.pricing.savingsMinor += value;
    result.startklar = { ...offer };
    return result;
  }
  function legacySyncUrl(href, recipe, enabled) {
    const url = new URL(href, BASE); url.searchParams.set('variant', recipe.parentVariantId);
    const offer = offerFor(recipe, enabled); if (offer) url.searchParams.set('startklar', offer.code); else url.searchParams.delete('startklar');
    return url.pathname + url.search + url.hash;
  }

  // ---------------------------------------------------------------------------
  // Mode 2, personal two-offer STARTKLAR Preisvorteil.
  // Link: /products/klassik-set?variant=<Klassik S2 parent>&startklar_once=<code>&startklar_fullday=<code>
  // Part Time and Full Time use the once code (Probier-Set Once value);
  // Comfort and All-in use the fullday code (Probier-Set Full Day value).
  // The shown amount always comes from Shopify's real quote allocation.
  // Without these parameters nothing below touches the page.
  // ---------------------------------------------------------------------------
  const PARAMS = Object.freeze({ once: 'startklar_once', fullday: 'startklar_fullday' });
  const KIND_BY_ROUTINE = Object.freeze({ part: 'once', full: 'once', comfort: 'fullday', allin: 'fullday' });
  const personalCode = /^SKC-[A-Z2-7]{24}$/;

  // Builder DOM the offer layer attaches to. qa/2026-09-24-startklar-two-offers
  // fails when the Builder stops producing any of these anchors.
  const ANCHORS = Object.freeze({
    topBox: '[data-bundle-limited-guarantee]',
    priceRow: '.judes-bundle__price-row',
    retailValue: '[data-bundle-retail-value]',
    routineCard: '.judes-bundle__routine-card',
    included: '[data-bundle-included]',
    includedGroup: '.judes-bundle__included-group',
    includedRow: '.judes-bundle__included-row',
    includedStatus: '.judes-bundle__included-status',
    summaryTotal: '[data-bundle-summary] .judes-bundle__total',
    summaryStruck: '[data-bundle-summary] .judes-bundle__total s',
    copy: '[data-bundle-copy]'
  });

  const COPY = {
    de: {
      names: { once: 'Probier-Set Once', fullday: 'Probier-Set Full Day' },
      offer: '{name} geschenkt: {amount} Preisvorteil',
      bonus: '{name} geschenkt (Preisvorteil: {amount})',
      label: 'Preisvorteil {name}',
      checking: 'Dein persönliches Angebot wird geprüft …',
      inactive: 'Dein Preisvorteil gilt für das Klassik-Set in Size 2.',
      invalid: 'Dieses persönliche Angebot ist nicht mehr gültig.',
      invalidTier: 'Der Preisvorteil für dieses Set ist nicht mehr gültig.',
      included: 'Enthalten'
    },
    en: {
      names: { once: 'Trial Set Once', fullday: 'Trial Set Full Day' },
      offer: '{name} on us: {amount} saving',
      bonus: '{name} on us (saving: {amount})',
      label: '{name} saving',
      checking: 'Checking your personal offer …',
      inactive: 'Your saving applies to the Classic Set in Size 2.',
      invalid: 'This personal offer is no longer valid.',
      invalidTier: 'The saving for this set is no longer valid.',
      included: 'Included'
    },
    fr: {
      names: { once: 'Kit d’essai Une fois', fullday: 'Kit d’essai Journée complète' },
      offer: '{name} offert : avantage de {amount}',
      bonus: '{name} offert (avantage : {amount})',
      label: 'Avantage {name}',
      checking: 'Vérification de votre offre personnelle …',
      inactive: 'Votre avantage s’applique à l’Ensemble classique en Size 2.',
      invalid: 'Cette offre personnelle n’est plus valable.',
      invalidTier: 'L’avantage pour cet ensemble n’est plus valable.',
      included: 'Inclus'
    },
    es: {
      names: { once: 'Set de Prueba Una Vez', fullday: 'Set de Prueba Día completo' },
      offer: '{name} de regalo: {amount} de ahorro',
      bonus: '{name} de regalo (ahorro: {amount})',
      label: 'Ahorro {name}',
      checking: 'Comprobando tu oferta personal …',
      inactive: 'Tu ahorro es válido para el Set Clásico en Size 2.',
      invalid: 'Esta oferta personal ya no es válida.',
      invalidTier: 'El ahorro para este set ya no es válido.',
      included: 'Incluido'
    },
    it: {
      names: { once: 'Set di prova Una volta', fullday: 'Set di prova Giornata Completa' },
      offer: '{name} in regalo: {amount} di risparmio',
      bonus: '{name} in regalo (risparmio: {amount})',
      label: 'Risparmio {name}',
      checking: 'Verifica della tua offerta personale …',
      inactive: 'Il tuo risparmio vale per il Set Classico in Size 2.',
      invalid: 'Questa offerta personale non è più valida.',
      invalidTier: 'Il risparmio per questo set non è più valido.',
      included: 'Incluso'
    }
  };

  const GIFT_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 6v16M12 6H8.46A1.98 1.98 0 0 1 6.5 4c0-1.1.88-2 1.96-2C11.21 2 12 6 12 6Zm0 0h3.54A1.98 1.98 0 0 0 17.5 4c0-1.1-.88-2-1.96-2C12.79 2 12 6 12 6ZM20 11v7.8c0 1.12 0 1.68-.22 2.11-.19.37-.49.68-.87.87C18.48 22 17.92 22 16.8 22H7.2c-1.12 0-1.68 0-2.11-.22a2 2 0 0 1-.87-.87C4 20.48 4 19.92 4 18.8V11M2 7.6v1.8c0 .56 0 .84.11 1.05.1.19.25.34.44.44.21.11.49.11 1.05.11h16.8c.56 0 .84 0 1.05-.11.19-.1.34-.25.44-.44.11-.21.11-.49.11-1.05V7.6c0-.56 0-.84-.11-1.05a1 1 0 0 0-.44-.44C21.24 6 20.96 6 20.4 6H3.6c-.56 0-.84 0-1.05.11a1 1 0 0 0-.44.44C2 6.76 2 7.04 2 7.6Z"/></svg>';

  const STYLE = `
.judes-bundle__limited-guarantee .judes-startklar-topline{color:#66469a;display:block;font-size:15px!important;font-weight:800;line-height:1.35;margin:0 0 3px}
.judes-bundle__limited-guarantee .judes-startklar-topline[data-state="checking"],.judes-bundle__limited-guarantee .judes-startklar-topline[data-state="inactive"],.judes-bundle__limited-guarantee .judes-startklar-topline[data-state="invalid"]{color:var(--bundle-muted,#756e7e);font-size:13.5px!important;font-weight:700}
.judes-startklar-topline[hidden],.judes-startklar-credit-row[hidden],.judes-startklar-summary-credit[hidden]{display:none!important}
.judes-startklar-standalone{align-items:center;background:var(--bundle-lilac-soft,#f0e9f8);border:1px solid #d8c8ea;border-radius:14px;margin:0 0 14px;padding:12px 16px}
.judes-startklar-bonus__icon{align-items:center;background:var(--bundle-lilac-soft,#f0e9f8);border-radius:10px;display:flex;flex:0 0 38px;height:38px;justify-content:center;width:38px}
.judes-startklar-bonus__icon svg,.judes-startklar-credit-row svg,.judes-startklar-summary-credit svg{fill:none;stroke:var(--bundle-purple,#7c5fa8);stroke-linecap:round;stroke-linejoin:round;stroke-width:1.8}
.judes-startklar-bonus__icon svg{height:20px;width:20px}
.judes-startklar-credit-row{align-items:center;background:var(--bundle-lilac-soft,#f0e9f8);border:1px solid #d8c8ea;border-radius:999px;color:var(--bundle-purple,#7c5fa8);display:inline-flex;font-size:12px!important;font-weight:800;gap:6px;line-height:1.3;margin:8px 0 0;padding:3px 10px 3px 7px}
.judes-startklar-credit-row svg,.judes-startklar-summary-credit svg{flex:0 0 15px;height:15px;stroke:currentColor;width:15px}
.judes-startklar-summary-credit{align-items:center;background:var(--bundle-lilac-soft,#f0e9f8);border:1px solid #d8c8ea;border-radius:12px;color:var(--bundle-purple,#7c5fa8);display:flex;font-size:14px!important;font-weight:800;gap:8px;margin:0 0 12px;padding:9px 12px}
.judes-startklar-summary-credit span{flex:1 1 auto}
.judes-startklar-summary-credit strong,.judes-startklar-credit-row strong{white-space:nowrap}
`;

  function kindFor(recipe) {
    return recipe && recipe.bundleType === 'klassik' && recipe.sizeKey === 's2' ? KIND_BY_ROUTINE[recipe.routineKey] || null : null;
  }

  function isOffer(state) {
    return !!(state && typeof state === 'object' && state.mode === 'offer' && state.codes);
  }

  // Version guard. `enabled` keeps its live meaning everywhere: "this page is a
  // legacy STARTKLAR2/3/4 gift link". An older Builder interface passes
  // entry.enabled as a plain boolean; an offer page therefore always reports
  // false, so a personal link can never become a legacy gift link.
  function legacyEnabled(state) {
    if (state && typeof state === 'object') return state.mode === 'offer' ? false : state.enabled === true;
    return state === true;
  }

  function offerEntry(url, recipes) {
    const classic = /\/products\/klassik-set\/?$/.test(url.pathname);
    const variantValues = url.searchParams.getAll('variant');
    const variantId = variantValues.length === 1 ? variantValues[0] : '';
    // The personal link names an exact Klassik Size 2 tier. Keep that tier even
    // when a code is invalid, so the customer lands where they clicked. Any other
    // Builder variant (Size 1 or Size 1 + 2) is the tier the customer switched to
    // before a reload: the codes stay available for Size 2.
    const linked = classic && variantId
      ? (recipes || []).find((recipe) => String(recipe.parentVariantId) === variantId) || null
      : null;
    const read = (param) => {
      const values = url.searchParams.getAll(param);
      return values.length === 1 && personalCode.test(values[0]) ? values[0] : '';
    };
    let once = read(PARAMS.once);
    let fullday = read(PARAMS.fullday);
    if (once && once === fullday) { once = ''; fullday = ''; }
    const slot = (code) => ({
      code: linked && code ? code : '',
      // checking: not verified yet; valid: a real Shopify quote allocated it;
      // invalid: missing, malformed, wrong link, or rejected by Shopify.
      status: linked && code ? 'checking' : 'invalid',
      amountMinor: 0
    });
    const codes = { once: slot(once), fullday: slot(fullday) };
    return { mode: 'offer', enabled: false, recipe: linked, requested: true, codes };
  }

  function usable(slot) {
    return !!(slot && slot.status !== 'invalid' && personalCode.test(String(slot.code || '')));
  }

  function entry(href, recipes) {
    const url = new URL(href, BASE);
    if (url.searchParams.has(PARAMS.once) || url.searchParams.has(PARAMS.fullday)) return offerEntry(url, recipes);
    const legacy = legacyEntry(url, recipes);
    legacy.mode = legacy.enabled ? 'legacy' : 'none';
    return legacy;
  }

  // The code slot the current tier uses, when it may still be applied.
  function activeSlot(state, recipe) {
    const kind = kindFor(recipe);
    const slot = kind ? state.codes[kind] : null;
    return usable(slot) ? slot : null;
  }

  function apply(result, recipe, catalog, state) {
    if (!isOffer(state)) return legacyApply(result, recipe, catalog, legacyEnabled(state));
    const slot = activeSlot(state, recipe);
    if (!slot) return result;
    // Only the matching personal code joins the normal set code: no gift units.
    result.discount.code += `,${slot.code}`;
    return result;
  }

  function syncUrl(href, recipe, state) {
    if (!isOffer(state)) return legacySyncUrl(href, recipe, legacyEnabled(state));
    const url = new URL(href, BASE);
    url.searchParams.set('variant', recipe.parentVariantId);
    url.searchParams.delete('startklar');
    // Usable codes stay in the address on every tier and size, so switching
    // back to Size 2 or reloading keeps the offer. Rejected codes leave it.
    for (const [kind, param] of Object.entries(PARAMS)) {
      const slot = state.codes[kind];
      if (usable(slot)) url.searchParams.set(param, slot.code);
      else url.searchParams.delete(param);
    }
    return url.pathname + url.search + url.hash;
  }

  function allocated(code, value) {
    if (!code || !value || !Array.isArray(value.orderDiscounts)) return 0;
    const wanted = String(code).toLowerCase();
    const amount = value.orderDiscounts
      .filter((discount) => discount && String(discount.code || '').toLowerCase() === wanted)
      .reduce((sum, discount) => sum + Number(discount.amountMinor || 0), 0);
    return Number.isSafeInteger(amount) && amount > 0 ? amount : 0;
  }

  // The Preisvorteil of the current tier in a verified quote, or 0.
  function creditMinor(state, value, recipe) {
    if (!isOffer(state)) return 0;
    const slot = activeSlot(state, recipe);
    return slot ? allocated(slot.code, value) : 0;
  }

  // Called with a failed quote (an Error) or a successful quote value for the
  // current tier. Returns true once, after marking that tier's personal code
  // invalid, so the Builder re-quotes without it:
  // - failure: Shopify reported the personal code itself as not applicable.
  //   A rejected set code alone is a set problem, never a verdict on the
  //   personal code: the normal Builder failure and retry handle it;
  // - success: the personal code was requested but Shopify allocated nothing.
  function rejectCredit(state, outcome, recipe) {
    if (!isOffer(state) || !outcome) return false;
    const slot = activeSlot(state, recipe);
    if (!slot) return false;
    const quoted = Number.isSafeInteger(outcome.finalPriceMinor) && Array.isArray(outcome.orderDiscounts);
    if (quoted) {
      if (allocated(slot.code, outcome) > 0) return false;
    } else {
      const rejected = Array.isArray(outcome.inapplicableCodes) ? outcome.inapplicableCodes.map((code) => String(code).toLowerCase()) : [];
      if (!rejected.includes(slot.code.toLowerCase())) return false;
    }
    slot.status = 'invalid';
    slot.amountMinor = 0;
    return true;
  }

  function languageOf(doc) {
    return String((doc && doc.documentElement && doc.documentElement.lang) || 'en');
  }

  function copyFor(doc) {
    return COPY[languageOf(doc).slice(0, 2).toLowerCase()] || COPY.en;
  }

  function fill(template, values) {
    return Object.entries(values).reduce((text, [key, value]) => text.split(`{${key}}`).join(String(value)), String(template));
  }

  function formatMoney(doc, currency, minor) {
    const whole = minor % 100 === 0;
    return new Intl.NumberFormat(languageOf(doc), {
      style: 'currency', currency: currency || 'EUR',
      minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2
    }).format(minor / 100);
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[char]));
  }

  function ensureStyle(doc, id, css) {
    if (!doc || !doc.head || typeof doc.getElementById !== 'function') return;
    let style = doc.getElementById(id);
    if (!style) {
      style = doc.createElement('style');
      style.id = id;
      doc.head.appendChild(style);
    }
    if (style.textContent !== css) style.textContent = css;
  }

  function ensureNode(parent, selector, create, place) {
    let node = parent.querySelector(selector);
    if (node) return node;
    node = create();
    place(node);
    return node;
  }

  function make(doc, tag, className, marker) {
    const node = doc.createElement(tag);
    node.className = className;
    node.setAttribute(marker, '');
    return node;
  }

  // Writes only when the content really changed, so assistive technology does
  // not re-announce the offer on every Builder re-render.
  function setContent(node, key, html) {
    if (node.getAttribute && node.getAttribute('data-startklar-key') === key) return false;
    node.innerHTML = html;
    if (node.setAttribute) node.setAttribute('data-startklar-key', key);
    return true;
  }

  function builderCopy(element) {
    if (element.__startklarBuilderCopy !== undefined) return element.__startklarBuilderCopy;
    let parsed = null;
    try { parsed = JSON.parse(element.querySelector(ANCHORS.copy).textContent); } catch (error) { parsed = null; }
    element.__startklarBuilderCopy = parsed;
    return parsed;
  }

  // Top box: the offer becomes the first line of the existing guarantee box.
  function renderTopLine(element, doc, view, text) {
    const box = element.querySelector(ANCHORS.topBox);
    const host = box ? (box.querySelector('p') || box) : null;
    let line;
    if (host) {
      line = ensureNode(host, '[data-startklar-topline]', () => {
        const node = make(doc, 'span', 'judes-startklar-topline', 'data-startklar-topline');
        node.setAttribute('role', 'status');
        node.setAttribute('aria-live', 'polite');
        node.setAttribute('aria-atomic', 'true');
        return node;
      }, (node) => host.insertBefore(node, host.firstChild));
    } else {
      // Fallback only if the guarantee box disappears: a standalone line above the routine card.
      const anchor = element.querySelector(ANCHORS.routineCard);
      if (!anchor || !anchor.parentNode) return;
      line = ensureNode(element, '[data-startklar-topline]', () => {
        const node = make(doc, 'p', 'judes-startklar-topline judes-startklar-standalone', 'data-startklar-topline');
        node.setAttribute('role', 'status');
        node.setAttribute('aria-live', 'polite');
        node.setAttribute('aria-atomic', 'true');
        return node;
      }, (node) => anchor.parentNode.insertBefore(node, anchor));
    }
    if (line.getAttribute('data-state') !== view) line.setAttribute('data-state', view);
    line.hidden = false;
    if (line.textContent !== text) line.textContent = text;
  }

  function bonusList(element) {
    const included = element.querySelector(ANCHORS.included);
    if (!included || typeof included.querySelectorAll !== 'function') return null;
    const groups = Array.from(included.querySelectorAll(ANCHORS.includedGroup));
    if (!groups.length) return null;
    const copy = builderCopy(element);
    const heading = (group) => { const h = group.querySelector('h4'); return h ? String(h.textContent || '').trim() : ''; };
    const group = (copy && copy.bonusItems && groups.find((candidate) => heading(candidate) === String(copy.bonusItems).trim()))
      || groups[groups.length - 1];
    return group.querySelector('ul');
  }

  // Bonus list: a second row under the Wickel-Coaching, same row style and badge.
  function renderBonus(element, doc, text, copy) {
    const list = bonusList(element);
    if (!list) return;
    let row = list.querySelector('[data-startklar-bonus]');
    if (!text) {
      if (row) row.remove();
      return;
    }
    const coaching = Array.from(list.children || []).find((child) => child !== row && child.matches && child.matches(ANCHORS.includedRow));
    const status = coaching && coaching.querySelector(ANCHORS.includedStatus);
    const badge = (status && String(status.textContent || '').trim())
      || ((builderCopy(element) || {}).included) || copy.included;
    if (!row) {
      row = make(doc, 'li', 'judes-bundle__included-row judes-startklar-bonus', 'data-startklar-bonus');
    }
    const after = coaching ? coaching.nextSibling : list.firstChild;
    if (row.parentNode !== list || (coaching && row.previousSibling !== coaching)) list.insertBefore(row, after);
    setContent(row, `${text}|${badge}`, `<span class="judes-startklar-bonus__icon" aria-hidden="true">${GIFT_ICON}</span>
          <span class="judes-bundle__included-name">${escapeHtml(text)}</span>
          <span class="judes-bundle__included-status">${escapeHtml(badge)}</span>`);
  }

  function renderRows(element, doc, label, amountText) {
    const show = !!amountText;
    const html = show ? `${GIFT_ICON}<span>${escapeHtml(label)}</span><strong>−${escapeHtml(amountText)}</strong>` : '';
    const priceRow = element.querySelector(ANCHORS.priceRow);
    if (priceRow && priceRow.parentNode) {
      const row = ensureNode(element, '[data-startklar-credit-row]', () => make(doc, 'p', 'judes-startklar-credit-row', 'data-startklar-credit-row'),
        (node) => priceRow.parentNode.insertBefore(node, priceRow.nextSibling));
      row.hidden = !show;
      setContent(row, show ? `${label}|${amountText}` : '', html);
    }
    const total = element.querySelector(ANCHORS.summaryTotal);
    if (total && total.parentNode) {
      const row = ensureNode(element, '[data-startklar-summary-credit]', () => make(doc, 'div', 'judes-startklar-summary-credit', 'data-startklar-summary-credit'),
        (node) => total.parentNode.insertBefore(node, total));
      row.hidden = !show;
      setContent(row, show ? `${label}|${amountText}` : '', html);
    }
  }

  // The cart drawer names each personal code by its Probier-Set. The generic
  // label in snippets/header-cart.liquid covers every other page.
  function renderDrawerLabels(doc, state, copy) {
    const rules = Object.keys(PARAMS).filter((kind) => personalCode.test(String(state.codes[kind].code || ''))).map((kind) => {
      const code = JSON.stringify(state.codes[kind].code);
      const label = JSON.stringify(fill(copy.label, { name: copy.names[kind] }));
      return `html body [data-discount-title=${code} i] .bundle-discount-title::after,html body [data-discount-title=${code} i] .cart-level-discount-title::after,html body [data-discount-code=${code} i] .cart-level-discount-title::after{content:${label}}`;
    });
    if (rules.length) ensureStyle(doc, 'judes-startklar-drawer-labels', rules.join('\n'));
  }

  // Render slot, called by the Builder after every price or summary paint.
  // Without the personal offer link this returns before touching anything.
  function render(element, state, recipe, value) {
    if (!isOffer(state) || !element) return;
    try {
      const doc = element.ownerDocument || root.document || null;
      const copy = copyFor(doc);
      const currency = element.dataset.currency || 'EUR';
      ensureStyle(doc, 'judes-startklar-style', STYLE);
      const kind = kindFor(recipe);
      const slot = activeSlot(state, recipe);
      const current = slot ? allocated(slot.code, value) : 0;
      if (current > 0) {
        slot.status = 'valid';
        slot.amountMinor = current;
      }
      let view;
      if (!kind) view = Object.values(state.codes).some(usable) ? 'inactive' : 'invalid';
      else if (!slot) view = 'invalid';
      else if (slot.status === 'valid' && slot.amountMinor > 0) view = 'valid';
      else view = 'checking';
      // Only this tier's code is gone while the other code still works: say so
      // for this set only. Both gone: the offer as a whole is no longer valid.
      const tierOnly = view === 'invalid' && !!kind && usable(state.codes[kind === 'once' ? 'fullday' : 'once']);
      const name = kind ? copy.names[kind] : '';
      const amountText = view === 'valid' ? formatMoney(doc, currency, slot.amountMinor) : '';
      const topText = view === 'valid' ? fill(copy.offer, { name, amount: amountText }) : copy[tierOnly ? 'invalidTier' : view];

      renderTopLine(element, doc, view, topText);
      renderBonus(element, doc, view === 'valid' ? fill(copy.bonus, { name, amount: amountText }) : '', copy);
      // Price chip and summary row appear only with a verified current quote.
      const currentText = view === 'valid' && current > 0 ? formatMoney(doc, currency, current) : '';
      renderRows(element, doc, fill(copy.label, { name }), currentText);
      renderDrawerLabels(doc, state, copy);

      // The Builder rounds the price up, the struck retail value up and the
      // saving down, so the three whole numbers may not add up. With the
      // Preisvorteil shown, keep them consistent: struck value = shown price +
      // shown saving. The price stays exact-or-up and the saving is never overstated.
      if (currentText && Number.isSafeInteger(value.finalPriceMinor) && Number.isSafeInteger(value.retailValueMinor)) {
        const whole = new Intl.NumberFormat(languageOf(doc), { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0 });
        const shownRetail = whole.format(Math.ceil(value.finalPriceMinor / 100)
          + Math.floor((value.retailValueMinor - value.finalPriceMinor) / 100));
        const retail = element.querySelector(ANCHORS.retailValue);
        if (retail && retail.textContent) retail.textContent = shownRetail;
        const struck = element.querySelector(ANCHORS.summaryStruck);
        if (struck && struck.textContent) struck.textContent = shownRetail;
      }
      element.dataset.startklarOfferState = view;
      element.dataset.startklarOfferKind = kind || '';
      element.dataset.startklarOfferMinor = String(view === 'valid' ? slot.amountMinor : 0);
      element.dataset.startklarOfferQuotedMinor = String(currentText ? current : 0);
    } catch (error) {
      // The offer display must never break the normal Builder.
    }
  }

  return {
    entry, apply, offerFor, syncUrl, rejectCredit, render, creditMinor, kindFor,
    personalCode, PARAMS, ANCHORS, COPY
  };
}));
